import Store from '@store';
import { constants as config, restrictions as restrictionsConfig } from '@config';
import { capitalizeFirstLetter } from 'src/utils/string';
import template from './template.hbs';
import placeholders from './placeholders.json';
import EditorFacade from '../../../facade/editor/editor';
import DesignFacade from '../../../facade/design/design';
import PlaceholdersFactory from '../../../factory/placeholders';
import { getAssetsData } from 'src/store/selectors/assets.selector';

module.exports = Backbone.View.extend({
  events: {
    'change select': 'selectPlaceholderEvent',
    'click .remove': 'removePlaceholderEvent',
    'click icon.show-placeholder': 'showPlaceholderEvent',
    'mouseover li.placeholders-list-item': 'mouseoverPlaceholderEvent',
    'mouseleave li.placeholders-list-item': 'mouseleavePlaceholderEvent'
  },

  _findElement: function (id) {
    let elem;

    if (id === 'background') {
      const image = document.querySelector(`#${config.background.image}`);
      const rect = document.querySelector(`#${config.background.color}`);

      elem = image || rect;
      if (!elem) elem = document.querySelector('#svgcontent g.background');
    } else {
      elem = document.getElementById(id);
    }

    return elem;
  },

  removePlaceholderEvent: function (event) {
    INKIVE.Modal.alertMessage(INKIVE.TranslateHelper.translate('tool.placeholders.list.remove_placeholder_alert'),
      {
        width: 450,
        callback: [
          _.bind(function () {
            const id = $(event.currentTarget).closest('li').data('element');
            const range = $(event.currentTarget).closest('li').data('range');

            const element = document.getElementById(id);
            element.removeAttribute(config.smartAssets.attributes.userInput);

            if (element.classList.contains('textarea')) {
              const textarea = new INKIVE.Text.Textarea().setDOM(element, false);
              if (!range) {
                textarea.text.removeSpecificPartialStyling(0, textarea.text.textContent.length, config.smartAssets.attributes.userInput);
              } else {
                const [start, end] = range.split('-');
                textarea.text.removeSpecificPartialStyling(Number(start), Number(end), config.smartAssets.attributes.userInput);
              }
              INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
            }

            this.render();
            this.setPlaceholderFlags();
          }, this), $.noop
        ]
      });
  },

  showPlaceholderEvent: function (event) {
    const id = $(event.currentTarget).closest('li').data('element');
    const canvas = INKIVE.Tool.getInstance().editor.canvas;

    canvas.setMode('select');

    INKIVE.DesignFacade.preSelect(id, true);

    const range = $(event.currentTarget).closest('li').data('range');
    if (range) {
      const [start, end] = range.split('-');
      const element = document.getElementById(id);

      INKIVE.EditorFacade.canvas.runExtensions('setSelection', { element, start: Number(start), end: Number(end) });
    }
  },

  mouseoverPlaceholderEvent: function (event) {
    const id = $(event.currentTarget).closest('li').data('element');
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const selectedElements = INKIVE.EditorFacade.selectedElements;
    const $elem = $(this._findElement(id));
    const placeholder = event.target.closest('.tab-content.placeholders ul.placeholders-list > li');
    const hasIconShowPlaceholder = placeholder.querySelector('icon.show-placeholder:hover');
    const hasIconRemove = placeholder.querySelector('icon.remove:hover');
    placeholder.style.background = !hasIconShowPlaceholder && !hasIconRemove ? '#F2F4F8' : '';

    const selector = canvas.selectorManager.requestSelector($elem[0]);
    (selectedElements && selectedElements[0] && selectedElements[0].id === id) || (selector && selector.showGrips(false));
  },

  mouseleavePlaceholderEvent: function (event) {
    const id = event.currentTarget.closest('li').dataset.element;
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const selectedElements = INKIVE.EditorFacade.selectedElements;
    const $elem = $(this._findElement(id));
    const placeholder = event.target.closest('.tab-content.placeholders ul.placeholders-list > li');
    placeholder.style.background = '';

    (selectedElements && selectedElements[0] && selectedElements[0].id === id) || canvas.selectorManager.releaseSelector($elem[0]);
  },

  selectPlaceholderEvent: function (event, ell) {
    const selectedByType = {};

    const isBackground = !this.$selectedElement.attr('id');

    if (isBackground) {
      const el = event.target;
      const targetElement = this.$selectedElement.find(`#${config.background[el.dataset.type]}`);

      if (el.value) {
        selectedByType[el.dataset.type] = el.value;
        targetElement.attr(config.smartAssets.attributes.userInput, el.value);
      } else {
        targetElement.removeAttr(config.smartAssets.attributes.userInput);
      }

      //cleanDefinedAssets(targetElement, selectedByType);
    } else {
      const options = _.chain(this.$el.find('select'))
        .map((el) => {
          if (el.value) {
            selectedByType[el.dataset.type] = el.value;
          }

          return el.value;
        })
        .compact()
        .value()
        .join(',');

      this.setAttributes(options);

      //cleanDefinedAssets(this.$selectedElement, selectedByType);
      INKIVE.ImagesFactory.addBBoxValues(this.$selectedElement.get(0));
    }

    this.setPlaceholderFlags();

    /*
    function cleanDefinedAssets (targetElement, userInputs) {
      const value = (targetElement.attr(config.smartAssets.attributes.definedAsset) || '').toString();
      let definedContentType = null;

      const remainDefinedAssets = value.split(',')
        .filter(id => {
          if (!id) return false;

          const definedAsset = getAssetsData(Store.getState(), 'definedAssets')(id);
          if (!definedAsset) return false;

          const type = config.smartAssets.typeToProperty[definedAsset.type];
          const shouldRemain = !userInputs[type];

          if (shouldRemain && !config.smartAssets.descriptionalTypes.includes(definedAsset.type)) {
            definedContentType = definedAsset.type;
          }

          return shouldRemain;
        });

      const { definedAsset: attr, definedContentType: typeAttr } = config.smartAssets.attributes;
      remainDefinedAssets.length
        ? targetElement.attr(attr, remainDefinedAssets)
        : targetElement.removeAttr(attr);
      definedContentType
        ? targetElement.attr(typeAttr, definedContentType)
        : targetElement.removeAttr(typeAttr);
    }*/
  },

  setAttributes: function (options) {
    const element = this.$selectedElement[0];

    if (!options) {
      element.removeAttribute(config.smartAssets.attributes.userInput);
    }

    const isEditing = INKIVE.EditorFacade.canvas.getMode() === 'textedit';
    if (!isEditing) {
      options && element.setAttribute(config.smartAssets.attributes.userInput, options);
      return;
    }

    element.removeAttribute(config.smartAssets.attributes.userInput);
    const textarea = new INKIVE.Text.Textarea().setDOM(element, false);
    const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});

    const isSegmentSelected = textarea.text.isSegmentSelected(range.start, range.end, config.smartAssets.attributes.userInput);

    if (!INKIVE.Text.Helpers.willNotShowSmartAssetConfirm && textarea.text.isRangeOverlapped(range.start, range.end, config.smartAssets.attributes.userInput) && !isSegmentSelected) {
      INKIVE.EditorFacade.handle('confirm', 'show', {
        labels: {
          title: INKIVE.TranslateHelper.translate('smart_assets.confirm_title'),
          description: INKIVE.TranslateHelper.translate('smart_assets.confirm_description'),
          remember: INKIVE.TranslateHelper.translate('top_submenu.animation.confirm_split_dont_ask_again'),
          confirmButton: INKIVE.TranslateHelper.translate('top_submenu.animation.confirm_split_submit'),
          cancelButton: INKIVE.TranslateHelper.translate('top_submenu.animation.confirm_split_cancel')
        },
        onConfirm: (remember) => {
          INKIVE.Text.Helpers.willNotShowSmartAssetConfirm = remember;
          this.handleStyling(textarea, range, options);

          INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
        },
        onCancel: () => {}
      });
    } else {
      this.handleStyling(textarea, range, options);

      INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
    }
  },

  handleStyling (textarea, range, options) {
    const attribute = config.smartAssets.attributes.userInput;
    const settings = { shouldRemoveOverlappedStyles: true };

    if (options) {
      textarea.text.setPartialStyling(range.start, range.end, attribute, options, settings);
      textarea.text.removeSpecificPartialStyling(range.start, range.end, config.smartAssets.attributes.definedAsset, undefined, settings);
    } else {
      textarea.text.removeSpecificPartialStyling(range.start, range.end, attribute, undefined, settings);
    }
  },

  initialize: function () {
    _.bindAll(this, 'updateTemplate');

    this.customFields = [];
    this.customPlaceholders = {};
    this.userInputs = {};

    const initCallback = ({ customPlaceholders, userInputs }) => {
      if (!PlaceholdersFactory.hasAutomationTemplates) return;

      const hasUserInputs = userInputs && !!Object.keys(userInputs).length;

      if (!customPlaceholders && !hasUserInputs) return;

      INKIVE.UserInfoFactory.getMembership().then(userInfo => {
        if (userInfo.permissions.assets_manage_automation_smart_asset) {
          $('[href=#tabPlaceholders]').parent().removeClass('hidden');
          if (hasUserInputs) this.setUserInputs(userInputs);
          if (customPlaceholders) this.setCustomPlaceholders(customPlaceholders);
        }
      });
    };

    EditorFacade.on('select', _.bind(this.setSelection, this));
    EditorFacade.on('editor.loaded', () => PlaceholdersFactory.init({ callback: initCallback }));
    EditorFacade.on('history.reload', () => this.refresh());
    EditorFacade.on('smart_asset.updated', () => this.refresh());
    EditorFacade.off('placeholder.selection_changed').on('placeholder.selection_changed', this.updateTemplate);
  },

  updateTemplate (buttonsFlagData) {
    if (buttonsFlagData.placeholderProcessed) return;

    buttonsFlagData.placeholderProcessed = true;

    this.el.querySelectorAll('option[value=""]').forEach(option => {
      option.selected = true;
    });

    if (!buttonsFlagData.customPlaceholder) return;

    const placeholders = buttonsFlagData.customPlaceholder.split(',');
    for (const placeholder of placeholders) {
      const option = this.el.querySelector('option[value="' + placeholder + '"]');
      if (!option) continue;
      option.selected = true;
    }
  },

  refresh: function () {
    INKIVE.Helpers.getActiveTab() === 'placeholders' && this.show();
  },

  show: function () {
    this.customFields = PlaceholdersFactory.getPlaceholdersInUse();

    this.render();
  },

  setSelection: function (elements) {
    this.selectedElement = _(elements).first();
    this.$selectedElement = this.selectedElement &&
      (this.selectedElement.id === 'background'
        ? $('#svgcontent').children('g.background')
        : $('#' + this.selectedElement.id));

    this.$el.is(':visible') && this.render();
  },

  render: function () {
    this.selectedElement
      ? this.renderPlaceholderOptions()
      : this.renderPlaceholderList();

    INKIVE.Helpers.initTooltips($(this.el.querySelector('div.tab-content.placeholders')));
  },

  renderPlaceholderOptions: function () {
    const type = this.selectedElement.type;

    const customFields = this.customFields.concat(this.customPlaceholders[type]);

    const isBackground = !this.$selectedElement.attr('id');
    const elements = isBackground
      ? Object.values(config.background)
        .reduce((acc, tag) => {
          const assetId = this.$selectedElement.find(`#${tag}`)?.attr(config.smartAssets.attributes.userInput);
          assetId && acc.push(assetId);

          return acc;
        }, [])
        .join(',')
      : this.$selectedElement.attr(config.smartAssets.attributes.userInput);

    const customPlaceholders = getCustomPlaceholders(elements);
    const userInputs = getOptionsData(type, this.userInputs);

    this.$el.html(template({
      type,
      custom_fields: mapOptions(customFields),
      options: userInputs,
      has_options: PlaceholdersFactory.hasAutomationTemplates && !!userInputs.length,
      has_selected_element: true
    }));

    if (customPlaceholders.length) {
      customPlaceholders.forEach(placeholder => {
        this.$el.find(`option[value="${placeholder}"]`)
          .closest('select')
          .val(placeholder);
      });
    }

    function mapOptions (options) {
      if (!Array.isArray(options)) return [];

      return options
        .filter((value, index, self) =>
          value &&
          isUnique(value, index, self)
        )
        .map(option => {
          const value = option;

          option = option.split('_');
          option = option.map(capitalizeFirstLetter);

          return {
            name: option.join(' '),
            value
          };
        });

      function isUnique (value, index, self) {
        return self.indexOf(value) === index;
      }
    }

    function getOptionsData (inputType, smartAssets) {
      return Object.entries(smartAssets)
        .filter(([name]) => config.smartAssets.assetsByType[inputType]?.includes(name.toLowerCase()))
        .map(([assetType, value]) => ({
          name: `Smart ${capitalizeFirstLetter(assetType)}`,
          type: assetType,
          data: mapSmartAssets(value)
        }));
    }

    function mapSmartAssets (options) {
      if (!Array.isArray(options)) return [];

      return options
        .map(({ id, name, type, value }) => ({
          name: capitalizeFirstLetter(name ?? `${type} ${id}`),
          value
        }));
    }

    function getCustomPlaceholders (placeholders) {
      if (!placeholders) return [];

      return String(placeholders).split(',');
    }
  },

  renderPlaceholderList: function () {
    const userInputAttr = config.smartAssets.attributes.userInput;
    const smartElements = [...document.querySelectorAll(`#svgcontent [${userInputAttr}]`)];

    const results = [];
    const processed = {};
    for (const element of smartElements) {
      if (element.tagName === 'tspan') {
        const parent = element.closest('g.textarea');
        const id = parent.id;

        if (processed[id]) continue;

        processed[id] = true;

        const data = DesignFacade.get(id);
        if (!data || !data.type) continue;

        const icon = restrictionsConfig.icons[data.type];

        const textarea = new INKIVE.Text.Textarea().setDOM(parent, false);
        textarea.text.detectSegment(config.smartAssets.attributes.userInput);

        let content = '';
        let range = [];

        let currentSegment = 0;
        const contents = [];
        const ranges = [];

        for (let i = 0; i < textarea.text.styles.length; i++) {
          const style = textarea.text.styles[i];
          if (!style.segment) continue;

          if (currentSegment !== style.segment) {
            content && contents.push(content);
            content = ' ';

            range.length && ranges.push(`${Math.min(...range)}-${Math.max(...range)}`);
            range = [];
          }

          currentSegment = style.segment;
          content += textarea.text.textContent.slice(textarea.text.realCharIndexToFake(style.start), textarea.text.realCharIndexToFake(style.end));

          range.push(style.start, style.end);
        }

        content && contents.push(content);
        range.length && ranges.push(`${Math.min(...range)}-${Math.max(...range)}`);

        for (let i = 0; i < contents.length; i++) {
          const title = contents[i];
          const textRange = ranges[i];

          results.push({
            element: id,
            name: `[${title}]`,
            range: textRange,
            icon
          });
        }
      } else {
        const id = element.classList.contains('background')
          ? 'background'
          : element.id;

        const data = DesignFacade.get(id);
        if (!data || !data.type) continue;

        const [, idNumber] = id.split('_');
        const name = `${data.type}${idNumber ? ` ${idNumber}` : ''}`;
        const icon = restrictionsConfig.icons[data.type];

        results.push({
          element: id,
          name,
          icon
        });
      }
    }

    this.$el.html(template({
      placeholders: results
    }));
  },

  setPlaceholderFlags: function () {
    PlaceholdersFactory.upToDate = false;
    PlaceholdersFactory.hasPlaceholdersInUse = !!$(`#svgcontent [${config.smartAssets.attributes.userInput}]`).length ||
      !!$(`#svgcontent [${config.smartAssets.attributes.definedAsset}`).length;

    INKIVE.DesignFacade.trigger('placeholder.update');
  },

  setCustomPlaceholders: function (customPlaceholders) {
    if (!customPlaceholders) {
      this.customPlaceholders = {};

      return;
    }

    this.customPlaceholders = Object.keys(customPlaceholders)
      .reduce((acc, next) => {
        const type = next.toLowerCase();
        const customPlaceholdersByType = customPlaceholders[next];
        const filteredCustomPlaceholders = customPlaceholdersByType
          .filter(item => !isDefaultPlaceholder.call(this, type, item))
          .sort();

        return $.extend(acc, { [type]: filteredCustomPlaceholders.sort() });
      }, {});

    function isDefaultPlaceholder (type, name) {
      const smartAssetsByType = (this.userInputs[type] || [])
        .map(item => item.value);

      return (placeholders[type] || [])
        .reduce((acc, next) => acc.concat(next.data), [])
        .concat(smartAssetsByType)
        .includes(name);
    }
  },

  setUserInputs: function (userInputs) {
    this.userInputs = userInputs;
  }
});
